module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/ar/img/fair-trade-high-growth.303d0a42.jpg";